import { createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import Types from '../Actions/Types';
import history from '../history'


export const INITIAL_STATE = Immutable({
    currentOrganization: {},
    covidGlobalDashboard: [],
    covidGoogleRSSFeed: [],
    covidGoogleRSSFeedImages: {},
    totalCovidData:[]
});

const storeOrganization = (state, action) => state.merge({currentOrganization: action.organization || {}})
const responseCovidGlobalDashboard = (state, action) => state.merge({covidGlobalDashboard: action.result})
const storeCovidData = (state, action) => state.merge({totalCovidData: action.result})

const responseCovidGoogleRSSFeed = (state, action) => {

    return state.merge({
        covidGoogleRSSFeed: action.result
    })
}

const responseCovidGoogleRSSFeedSingleImage = (state, action) => {

    return state.merge({
        covidGoogleRSSFeedImages: { ...state.covidGoogleRSSFeedImages, [action.result.index]: action.result.image }
    })
}

const responseCovidGoogleRSSFeedImage = (state, action) => {

    return state.merge({
        covidGoogleRSSFeedImages: { ...state.covidGoogleRSSFeedImages, ...action.result }
    })
}


const responseCovidDeclarationOverallSymptomsV2 = (state, action) => {

    return state.merge({
        covidDeclarationSymptomsV2: action.result
    })
}

const ACTION_HANDLERS = {
    [Types.STORE_ORGANIZATION]: storeOrganization,
    [Types.RESPONSE_GLOBAL_COVID_DASHBOARD]: responseCovidGlobalDashboard,
    [Types.RESPONSE_COVID_GOOGLE_RSS_FEED]: responseCovidGoogleRSSFeed,
    [Types.SET_COVID_DATA]:storeCovidData,
    [Types.RESPONSE_COVID_DECLARATION_OVERALL_SYMPTOMS_V2]: responseCovidDeclarationOverallSymptomsV2,
    [Types.RESPONSE_COVID_GOOGLE_RSS_FEED_SINGLE_IMAGE]: responseCovidGoogleRSSFeedSingleImage,
    [Types.RESPONSE_COVID_GOOGLE_RSS_FEED_IMAGE]: responseCovidGoogleRSSFeedImage,
};



export default createReducer(INITIAL_STATE, ACTION_HANDLERS)